import React from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
const ConfirmModal = ({ isOpen, onSubmit, toggle, color, message, title }) => {
  return (
    <Modal centered isOpen={isOpen} toggle={toggle} size="sm">
      <ModalHeader className="border-bottom-0">
        <FontAwesomeIcon
          icon={faExclamationCircle}
          className={`text-${color}`}
        />{" "}
        {title}
      </ModalHeader>
      <ModalBody>{message}</ModalBody>
      <Row noGutters className="mb-2">
        <Col xs="auto" className="ml-auto">
          <Button color={color} onClick={onSubmit}>
            Confirm
          </Button>
        </Col>
        <Col xs="auto">
          <Button color="link" onClick={toggle}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ConfirmModal;
